export default __webpack_public_path__ + "static/media/vip-banner-m-ms.192df480.webp";